import { computed, toRefs } from 'vue'
import List from 'dcode/classes/List'
import useWatch from 'dcode/uses/useWatch'

export default function useList (props, propSelected = undefined) {
  const { list } = toRefs(props)
  return useWatch(list, () => {
    const list = new List(
      props.list,
      props.listInit,
      props.translation,
      props.keyText,
      props.keyValue
    ).get()

    if ('selected' in props || propSelected) {
      list.forEach(item => {
        item.selected = computed(() => {
          return {
            'status-selected': propSelected
              ? item.value === propSelected.value
              : item.value === props.selected
          }
        })
      })
    }

    return list
  }, ['init'])
}
